import MonthRangePicker from "@components/inputs/date/MonthRangePicker";
import { IDayInterval } from "@components/inputs/date/utils";
import { getSharedInputProps, IInputOnChangeEvent } from "@components/inputs/input";
import { getDateFromMonth, getMonthFromDate } from "@components/smart/Smart.utils";
import BindingContext from "@odata/BindingContext";
import { isDefined, isNotDefined } from "@utils/general";
import React, { Component } from "react";

import { Model } from "../../../model/Model";
import { IValidationError } from "../../../model/Validator.types";
import DateType, { getUtcDayjs } from "../../../types/Date";

interface IProps {
    storage: Model;
    bindingContext: BindingContext;
    onChange: (data: IInputOnChangeEvent) => void;
    width?: string;
    error?: IValidationError;
    fromPath: string;
    toPath: string;
    year?: number;
}

type TMonthRangePickerVal = number | Date;

class SmartMonthRangePicker extends Component<IProps> {
    handleChange = (e: IInputOnChangeEvent<IDayInterval>): void => {
        const { storage, bindingContext, toPath, fromPath, onChange, year } = this.props;
        const value = e.value;

        if (DateType.isValid(value?.from) && DateType.isValid(value?.to)) {
            const { from, to } = value;
            const fromValue = isDefined(year) ? getUtcDayjs(from).set("year", year).startOf("month").toDate() : getMonthFromDate(from);
            const toValue = isDefined(year) ? getUtcDayjs(to).set("year", year).endOf("month").toDate() : getMonthFromDate(to);

            const parentBc = bindingContext.getParent();
            storage.setValue(parentBc.navigate(fromPath), fromValue);
            storage.setValue(parentBc.navigate(toPath), toValue);
        }

        if (storage.hasError(bindingContext)) {
            storage.clearError(bindingContext);
        }

        onChange({
            value: {
                from: value?.from,
                to: value?.to
            }
        });

        storage.refresh();
    }

    getValue = (): IDayInterval => {
        const { storage, fromPath, toPath, bindingContext, year } = this.props;
        const parentBc = bindingContext.getParent();

        const from = storage.getValue(parentBc.navigate(fromPath)) as TMonthRangePickerVal;
        const to = storage.getValue(parentBc.navigate(toPath)) as TMonthRangePickerVal;
        if (isNotDefined(from) || isNotDefined(to)) {
            return null;
        }

        if (isDefined(year)) {
            return {
                from: from as Date,
                to: to as Date
            };
        }
        return {
            from: getDateFromMonth(from as number),
            to: getDateFromMonth(to as number, true)
        };
    };

    render() {
        return <MonthRangePicker value={this.getValue()}
                                 onChange={this.handleChange}
                                 {...getSharedInputProps(this.props)}/>;
    }
}

export default SmartMonthRangePicker;